import React, { useState } from "react";
import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import logoMet from "../../assets/icon_Metlife_Header.jpg";
import { Alert, UseImage } from "../../components/";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/actions";
import { useNavigate } from "react-router-dom";
import { authRequests } from "../../services";
import { AccountCircle } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  imagenLogin: {
    height: "32px",
    backgroundRepeat: "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem"
  }
}));

export default function LoginMultiRol(props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles(theme);
  const auth = useSelector((state) => state.Authentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedIndex, setSelectedIndex] = useState({
    index: null,
    data: null,
  });

  if (!auth.roles || !auth.roles.length) return;

  const handleListItemClick = (data, index) => {
    setSelectedIndex({ index, data });
  };

  const handleSignInOnTenant = async () => {
    try {
      if (!selectedIndex.data) return;
      //crear input de tokens a revocar
      const TokensDisable = auth.roles
        .filter((rol) => rol.Token !== selectedIndex.data.Token)
        .map((rol) => ({
          Token: rol.Token,
          UserId: rol.UserLoginData.Id,
        }));
      await authRequests.RevokeUserTokens({ TokensDisable });

      const { Token, UserLoginData, WorkFlowData } = selectedIndex.data;
      // setear data en localStorage
      sessionStorage.setItem("token", Token);
      sessionStorage.setItem("WorkFlowData", WorkFlowData?.WorkFlowName);
      sessionStorage.setItem(
        "userName",
        `${UserLoginData.Name} ${
          UserLoginData.FatherLastName || UserLoginData.MotherLastName
        }`
      );
      localStorage.setItem("AuthData", selectedIndex.data);
      dispatch(authActions.AuthenticationTenant(selectedIndex.data));
    } catch (error) {
      console.log(error.response);
      Alert(
        {
          icon: 0,
          title: error?.response?.status || "",
          text: error?.response?.data
            ? `${error?.response?.data?.Messages}. TransactionId: ${error?.response?.data?.TransactionId}`
            : "",
        },
        () => handleClearData()
      );
    }
  };

  const handleClearData = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/auth");
  }

  return (
    <Box mt={8}>
      <Box display="flex" gap={2} justifyContent="center" alignItems="center">
        <UseImage src={logoMet} type="img" className={classes.imagenLogin} />
        <Typography variant="h3">
          <b>{t("login_sign_in")}</b>
        </Typography>
      </Box>
      <br />
      <Typography align="center" sx={{ fontWeight: "100" }}>
        {t("multiple_users_detected")}
      </Typography>
      <Box my={3}>
        <List disablePadding>
          {auth.roles.map((res, index) => {
            return (
              <ListItemButton
                key={index}
                selected={selectedIndex.index === index}
                onClick={() => handleListItemClick(res, index)}
                sx={{ borderBottom: "1px solid", borderColor: "divider" }}
              >
                <ListItemIcon>
                  <AccountCircle fontSize="large" />
                </ListItemIcon>
                <ListItemText
                  primary={res.UserLoginData.FullName}//{res.WorkFlowData.WorkFlowName}
                  secondary={`${res.UserLoginData.Username}`}//{res.UserLoginData.SecurityLoginData.Roles[0].Name}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
      <Box className={classes.buttonsContainer}>
        <Button
          id="btnSignInMulti"
          fullWidth
          variant="contained"
          sx={{ height: 48 }}
          disabled={!selectedIndex.data}
          onClick={() => handleSignInOnTenant()}
        >
          {t("login_sign_in")}
        </Button>
        <Button
          id="btnSignOutMulti"
          fullWidth
          variant="outlined"
          sx={{ height: 48 }}
          onClick={handleClearData}
        >
          {t("button_back")}
        </Button>
      </Box>
    </Box>
  );
}
